import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
		showSearchBox: false,
		showTeleBox: false,
		isDarkMode: false,
	},
	computed: {
		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		},

		phoneView: function () {
			if (VOFFICE.phoneView) {
				return VOFFICE.phoneView;
			}
		},

	},

	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});
		//this.initDropdownEventListeners();

		const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
		const savedMode = localStorage.getItem("mode_" + suffix);
		if (savedMode === "dark") {
			this.isDarkMode = true;
			document.body.classList.add("dark");
		}

		$(".menu-toggler").click(function () {
			$(this).next(".dropdown-menu").slideToggle();
			$(this).toggleClass("open");
		});
		$(".menu-toggler").click(function () {
			$(this).next(".drp-menu").slideToggle();

		});

		if (window.screen.width > 992) {
			$(".searchlink").click(function () {
				$(".main-menu").addClass('hide-menu');
			});
			$("#searchDropDown").hover(function () {
				$(".main-menu").removeClass('hide-menu');
			});
		}

		/*if (window.screen.width > 1199) {
			$(".searchlink").click(function () {
				$(".main-menu").addClass('hide-menu');
			});
			$("#searchDropDown").hover(function () {
				$(".main-menu").removeClass('hide-menu');
			});
		}*/

	},

	methods: {

		toggleMode: function () {
			this.isDarkMode = !this.isDarkMode;
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			if (this.isDarkMode) {
				document.body.classList.add("dark");
				localStorage.setItem("mode_" + suffix, "dark");
			} else {
				document.body.classList.remove("dark");
				localStorage.setItem("mode_" + suffix, "light");
			}
		},
		scrollToTop: function () {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		},


		toggleSearchbox: function (event) {
			this.showSearchBox = !this.showSearchBox;
			var searchBox = document.getElementById("header-fastnav-search");
			var searchIcon = document.getElementById("search-icon");
			var searchBoxClose = document.getElementById("search-box-close");
			var searchBoxInput = document.getElementById("search-box-input");
			var searchBoxBtn = document.getElementById("search-box-btn");
			if (this.showSearchBox) {
				this.showTeleBox = false;
				this.showSettings = false;
				this.$nextTick(() => {
					if (searchBox) {
						searchBox.focus();
						if (searchBoxClose) {
							searchBoxClose.tabIndex = 0;
						}
						if (searchBoxInput) {
							searchBoxInput.tabIndex = 0;
						}
						if (searchBoxBtn) {
							searchBoxBtn.tabIndex = 0;
						}
					}
				});
			} else {
				if (searchBox) {
					searchBox.blur();
					searchBox.tabIndex = -1;
					if (searchBoxClose) {
						searchBoxClose.tabIndex = -1;
					}
					if (searchBoxInput) {
						searchBoxInput.tabIndex = -1;
					}
					if (searchBoxBtn) {
						searchBoxBtn.tabIndex = -1;
					}
				}
				if (searchIcon) {
					searchIcon.focus();
				}
			}
		},
		toggleTelebox: function (event) {
			this.showTeleBox = !this.showTeleBox;
			var telebox = document.getElementById("tele-box");
			var phoneIcon = document.getElementById("phone-icon");
			var teleBoxClose = document.getElementById("tele-box-close");
			var teleBoxLink = document.getElementById("tele-box-link");

			if (this.showTeleBox) {
				this.showSearchBox = false;
				this.showSettings = false;
				this.$nextTick(() => {
					if (telebox) {
						telebox.focus();
						if (teleBoxClose) {
							teleBoxClose.tabIndex = 0;
						}
						if (teleBoxLink) {
							teleBoxLink.tabIndex = 0;
						}
					}
				});
			} else {
				if (telebox) {
					telebox.blur();
					telebox.tabIndex = -1;
					if (teleBoxClose) {
						teleBoxClose.tabIndex = -1;
					}
					if (teleBoxLink) {
						teleBoxLink.tabIndex = -1;
					}
				}
				if (phoneIcon) {
					phoneIcon.focus();
				}
			}
		},
		toggleSettings: function (event) {
			this.showSettings = !this.showSettings;
			var settings = document.getElementById("settings");
			var contrastLink = document.getElementById("contrastLink");
			var typeLink = document.getElementById("typeLink");
			if (this.showSettings) {
				settings.focus();
				contrastLink.tabIndex = 0;
				typeLink.tabIndex = 0;
				this.showSearchBox = false;
				this.showTeleBox = false;
			} else {
				settings.blur();
				contrastLink.tabIndex = -1;
				typeLink.tabIndex = -1;
			}
		},
		phoneLink: function () {
			if (VOFFICE.phoneLink) {
				var el = document.getElementById('preloader');

				window.location.href = VOFFICE.phoneLink;
				if (el) {
					el.style.display = "none";
				}
			}
		},
		navbarToggle: function () {
			if (window.screen.width < 993) {


				$('.main-menu').slideToggle();
				$('.navbar-v1').removeClass('open-by-mob');
				$("body").toggleClass("menuOpen");

				this.showTeleBox = false;
				this.showSearchBox = false;
			}

		},

		favCount: favCount,
		goSearch: function () {
			if (isBlank(this.name)) {
				window.location.href = 's';
			} else {
				window.location.href = 's#?name=' + encodeURIComponent(this.name);
			}
		},
		toggleDropdownOnEnter: function (event) {
			if (event.keyCode === 13) {
				event.preventDefault();

				var dropdownToggle = event.target;
				var dropdownMenu = dropdownToggle.nextElementSibling;


				var isOpen = dropdownToggle.classList.contains('show');

				if (!isOpen) {
					dropdownToggle.classList.add('show');
					dropdownMenu.classList.add('show');
				}
			}
		},


		initDropdownEventListeners: function () {
			var dropdownToggles = document.querySelectorAll('.dropdown-toggle');
			dropdownToggles.forEach(toggle => {
				toggle.addEventListener('keydown', this.toggleDropdownOnEnter);
			});
		},

	}


};